import SelectionInboxGridRow from "./SelectionInboxModel/SelectionInboxGridRow"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function UpdateStatusToPending(data: SelectionInboxGridRow) {
  const tests = {
    TestEventID: data.TestEventID,
    MockTestDetailID: data.TestDetailID,
    FormFoxTestAN: data.FormFoxTestAN,
  }
  
  const params: string = JSON.stringify(tests)
  return ObservableFromFetch<string>("WorkforceRandomTest/UpdateStatusToPending", params, "put")
}
